import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Box from "@material-ui/core/Box";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import clsx from "clsx";
import moment from "moment";
import "./styles.scss";
import { Typography } from "@material-ui/core";
const useStyles = makeStyles({
  table: {},
  tableRightBorder: {
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.1)",
    borderStyle: "solid",
  },
  tableFont: {
    fontSize: "16px",
    fontFamily: "Montserrat",
  },
  tableHeader: {
    fontSize: "16px",
    fontFamily: "Montserrat",
    color: "#212529",
    fontWeight: 600,
  },
  root: {
    padding: "60px 10% 5px",
    overflowX: "scroll",
  },
  emptyDocDetails: {
    fontFamily: "Montserrat",
    fontSize: "16px",
    color: "#277acc",
    minHeight: "7rem",
    position: "relative",
    top: "2.5rem",
  },
});

const data = [
  {
    name: "Document 1",
    uploadDate: `${new Date().getDate()}-${new Date().getMonth()}-${new Date().getFullYear()}`,
    uploadedBy: "Dikshit",
  },
  {
    name: "Document 2",
    uploadDate: `${new Date().getDate()}-${new Date().getMonth()}-${new Date().getFullYear()}`,
    uploadedBy: "Rupali",
  },
  {
    name: "Document 3",
    uploadDate: `${new Date().getDate()}-${new Date().getMonth()}-${new Date().getFullYear()}`,
    uploadedBy: "Deepak",
  },
  {
    name: "Document 4",
    uploadDate: `${new Date().getDate()}-${new Date().getMonth()}-${new Date().getFullYear()}`,
    uploadedBy: "Mayuri",
  },
];

const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));

export default function BasicTable(props) {
  const classes = useStyles();
  const [listData, setListData] = useState("");
  useEffect(() => {
    if (props.childData) {
      setListData(listData);
    }
  }, [props.childData]);
  return (
    <Box className={clsx(classes.root, "mntrshipdoctableengesum")}>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell
                className={clsx(classes.tableRightBorder, classes.tableHeader)}
              >
                NO.
              </TableCell>
              <TableCell
                className={clsx(classes.tableRightBorder, classes.tableHeader)}
              >
                DOCUMENT NAME
              </TableCell>
              <TableCell
                className={clsx(classes.tableRightBorder, classes.tableHeader)}
              >
                UPLOAD DATE
              </TableCell>
              <TableCell
                className={clsx(classes.tableRightBorder, classes.tableHeader)}
              >
                UPLOADED BY
              </TableCell>
              <TableCell
                className={clsx(classes.tableRightBorder, classes.tableHeader)}
              >
                VIEW
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props?.childData !== "NoRecords" &&
              props?.childData.map((datum, index) => (
                <TableRow key={index}>
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableFont,
                      "datetimeuplddoctable"
                    )}
                  >
                    {index + 1}
                  </TableCell>
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableFont,
                      "datetimeuplddoctable"
                    )}
                  >
                    {datum.documentName}
                  </TableCell>
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableFont,
                      "datetimeuplddoctable"
                    )}
                  >
                    {moment(datum.uploadDate).format("DD-MM-YYYY hh:mm A")}
                  </TableCell>
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableFont,
                      "datetimeuplddoctable"
                    )}
                  >
                    {datum.uploadedBy}
                  </TableCell>
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableFont,
                      "datetimeuplddoctable"
                    )}
                  >
                    <div className="newuserTooltip">
                      <a
                        href={datum.documentPath}
                        target="_blank"
                        style={{
                          color: "#3ac2d7",
                          textDecoration: "underline",
                          fontFamily: "Montserrat",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Click to View &#62;
                      </a>
                      <span
                        className="tooltiptext  tooltip-bottom"
                        style={{ left: "57px" }}
                      >
                        View Document
                      </span>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            {/* {data.map((datum, index) => (
              <TableRow key={index}>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>{index + 1}</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>{datum.name}</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>{datum.uploadDate}</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>{datum.uploadedBy}</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>
                    <Box style={{textDecoration: 'underline', color: '#3ac2d7'}} >
                        {"Click to View >"}
                    </Box>
                </TableCell>
              </TableRow>
            ))} */}
          </TableBody>
        </Table>
        {props?.childData === "NoRecords" && (
          <>
            <Typography className={classes.emptyDocDetails}>
              There are no documents uploaded currently.
              {props.mentorshipStatus === "CLOSED" ? (
                ""
              ) : (
                <>
                  {" "}
                  {value?.id !== props?.data?.cohortAdminId && (
                    <>
                      To upload a document{" "}
                      <span
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                          marginLeft: "7px",
                        }}
                        onClick={() => {
                          if (
                            localStorage.getItem("SavedLoggedInData") &&
                            JSON.parse(
                              localStorage.getItem("SavedLoggedInData")
                            )?.role !== "Admin"
                          ) {
                            props.openDocModal(true);
                          }
                        }}
                      >
                        Click Here
                      </span>
                    </>
                  )}
                </>
              )}
            </Typography>
          </>
        )}
      </TableContainer>
    </Box>
  );
}
